import React, { FC, useState } from 'react';
import styled from 'styled-components';

import ExpandCollapse from 'src/images/ExpandCollapse.svg';

type ExpandCollapseProps = {
  payload: any;
  payloadType: string;
  lookupType: string;
};

const ExpandCollapsePayload: FC<ExpandCollapseProps> = ({ payload, lookupType, payloadType }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const tryParseJSON = payload => {
    try {
      const obj = JSON.parse(payload);
      if (obj && typeof obj === 'object') {
        return obj;
      }
    } catch (e) {
      return payload;
    }
    return payload;
  };

  // Did we receive the expected props?
  if (!payload || !lookupType || !payloadType) return null;

  return (
    <>
      <ToggleExpandCollapse data-aid={`toggle-${lookupType}-${payloadType}-view`} onClick={toggleExpanded}>
        <StyledImage src={ExpandCollapse} />
        <StyledToggleText>
          {isExpanded ? 'Collapse' : 'Expand'} the {payloadType}
        </StyledToggleText>
      </ToggleExpandCollapse>
      {isExpanded ? (
        <ExpandedPayload data-aid={`expanded-${lookupType}-${payloadType}-view`}>
          {JSON.stringify(tryParseJSON(payload), null, 2)}
        </ExpandedPayload>
      ) : null}
    </>
  );
};

export default ExpandCollapsePayload;

const StyledImage = styled.img`
  cursor: pointer;
  margin-right: 8px;
  vertical-align: middle;
`;

const ToggleExpandCollapse = styled.div`
  margin: 8px 0px;
`;

const StyledToggleText = styled.div`
  cursor: pointer;
  margin-bottom: 8px;
  text-decoration: underline;
  display: inline;
`;

const ExpandedPayload = styled.div`
  white-space: break-spaces;
  font-family: 'Courier';
`;
